export type RootLandingRoute = 'loading' | 'dashboard' | 'public';

type RootLandingState = {
  authLoading: boolean;
  isAuthenticated: boolean;
  hasPersistedSessionHint: boolean;
  /** Google/Apple returned to `/?state=...&code=...` and the callback is still routing. */
  hasPendingProviderCallback?: boolean;
};

/**
 * Authenticated returning users keep a workspace splash until Auth0/JWT
 * hydration finishes, so marketing copy never flashes before /dashboard.
 * Anonymous first visits paint the public homepage immediately.
 */
export const resolveRootLandingRoute = ({
  authLoading,
  isAuthenticated,
  hasPersistedSessionHint,
  hasPendingProviderCallback = false,
}: RootLandingState): RootLandingRoute => {
  // A provider callback lands on `/` before the auth context sends the user to
  // their saved destination. Redirecting to /dashboard here raced that and
  // sometimes won, dropping the destination. The callback's success path always
  // leaves `/`; signed-out visitors keep the old behavior.
  if (isAuthenticated && hasPendingProviderCallback) return 'loading';
  if (isAuthenticated) return 'dashboard';
  if (authLoading && hasPersistedSessionHint) return 'loading';
  return 'public';
};
